<div id="publish-form" class="pt-2">
	<div class="d-flex align-items-center justify-content-center flex-wrap py-2">
		@for(dataItem of data; track dataItem; let index = $index) {
		<div class="w-100 d-flex align-items-center justify-content-center" [style.background-color]="$odd ? 'var(--theme-palette-100)' : ''">
			<div class="d-flex align-items-center justify-content-center py-4" [class]="mobileView ? 'w-100' : 'w-75'">
				<div
					class="text-block-container d-flex flex-wrap align-items-center justify-content-start w-100"
					[ngClass]="{ 'flex-row-reverse': $even, 'flex-row': $odd, highlight: dataItem.type === 'highlight' }">
					@for(content of dataItem.content; track content; let contentIndex = $index) {
					<div class="d-flex flex-wrap p-3 pe-4 w-100 justify-content-start w-100">
						@if(dataItem.leading) {
						<div class="d-flex w-100">
							<div class="blob me-2" [class]="$even ? 'style-1' : 'style-2'"></div>
							<span class="small-heading"> {{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.leading | translate }}</span>
						</div>
						} @if(content.title) {
						<div class="w-100 mt-2 mb-5">
							<span class="heading mb-2">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.title | translate }}</span>
						</div>
						}

						<p class="m-0 p-0">
							@if (content.leading) {
							<strong>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.leading | translate }}</strong>
							} @if(content.text) {
							{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.text | translate }}
							}
						</p>
					</div>
					}
				</div>
			</div>
		</div>
		}
	</div>

	<div class="d-flex align-items-center justify-content-center flex-wrap">
		<div class="my-2 p-2" [class]="mobileView ? 'w-100' : 'w-50'">
			<form class="d-flex flex-wrap" [formGroup]="formGroup" #formContactInfoDirective="ngForm" (submit)="sendMessage(formContactInfoDirective)">
				<mat-form-field class="w-100 pb-3">
					<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PUBLISH_FORM_COMPANY' | translate }}</mat-label>
					<input type="text" formControlName="company" matInput />
				</mat-form-field>

				<mat-form-field class="w-100 pb-3">
					<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PUBLISH_FORM_SUBJECT' | translate }}</mat-label>
					<input type="text" formControlName="subject" matInput />
				</mat-form-field>

				<mat-form-field class="w-100 pb-3">
					<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PUBLISH_FORM_DELIVERY_DATE' | translate }}</mat-label>
					<input matInput id="delivery-date" [matDatepicker]="deliveryDatePicker" formControlName="deliveryDate" />
					<mat-datepicker-toggle tabindex="-1" matIconSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
					<mat-datepicker #deliveryDatePicker></mat-datepicker>
				</mat-form-field>

				<mat-form-field class="w-100 pb-3">
					<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PUBLISH_FORM_CONTACT_NAME' | translate }}</mat-label>
					<input type="text" formControlName="contactName" matInput />
				</mat-form-field>

				<mat-form-field class="w-100 pb-3" appearance="outline">
					<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PUBLISH_FORM_CONTACT_E_MAIL' | translate }}</mat-label>
					<input type="text" formControlName="emailFrom" matInput />
				</mat-form-field>

				<mat-form-field class="w-100 pb-3" appearance="outline">
					<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PUBLISH_FORM_CONTACT_PHONE' | translate }}</mat-label>
					<input type="number" formControlName="phone" matInput />
				</mat-form-field>

				<mat-form-field class="w-100 pb-3" appearance="outline">
					<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PUBLISH_FORM_TEXT' | translate }}</mat-label>
					<textarea matInput class="w-100 pb-1" formControlName="message" cdkTextareaAutosize cdkAutosizeMinRows="10" cdkAutosizeMaxRows="10"></textarea>
				</mat-form-field>

				<button type="submit" mat-raised-button color="primary" class="w-100" aria-label="send message button" [disabled]="formGroup.invalid || apiLoading.contactForm">
					@if(apiLoading.contactForm) {
					<mat-spinner diameter="20"></mat-spinner>
					} @else {
					<span>{{ 'BUTTON.SEND' | translate }}</span>
					}
				</button>
			</form>
		</div>

		<div class="break"></div>
	</div>
</div>
